import {
  ColorsPrimary500,
  Dimensions1,
  Dimensions2,
  Dimensions8,
} from '@efexteam/design-tokens';
import { css } from '@emotion/css';

const headerSection = css({
  '&.MuiBox-root': {
    display: 'flex',
    alignItems: 'center',
    gap: Dimensions1,
    marginBottom: Dimensions8,
  },
});

const userRoleChip = css({
  '&.MuiChip-root': {
    backgroundColor: 'transparent !important',
    fontSize: '10px',
    marginLeft: Dimensions2,
  },
});

const sectionButtons = (activeView: boolean) =>
  css({
    '&.MuiButton-root': {
      borderRadius: '0px',
      borderBottom: activeView ? `2px solid ${ColorsPrimary500}` : 'none',
      color: activeView ? ColorsPrimary500 : 'inherit',
    },
  });

const ProfileStyles = {
  headerSection,
  userRoleChip,
  sectionButtons,
};

export default ProfileStyles;
